import { batch } from 'react-redux';
import { getMemberVerify } from 'Api/AccountApi';
import { localStorageGet, localStorageSet, localStorageRemove } from 'Utils/Storage';
import {
  SET_BANGO,
  CLEAR_INTEGRATIONS,
  SET_INITIAL_SHEER_STEP,
  SET_REDIRECT_URL,
  CLEAR_SHEER_ID,
  SET_SHEER_PROGRAM,
  SET_SHEER_VERIFICATION_ID,
  SET_VETERANS_ADV_ID,
  SET_VETERANS_ADV_ERROR,
  CLEAR_VETERANS_ADV_ERROR,
  CLEAR_VETERANS_ADV_ID,
} from '../Types';
import { sanitizePath } from 'Utils/Path';

const MOCK_SHEER_ERROR = {
  errorType: 'Not Found',
  errorMessage: 'verification id not found',
};

// action creators
export const setBango = (payload) => ({ type: SET_BANGO, payload });
export const resetIntegrations = () => ({ type: CLEAR_INTEGRATIONS });
export const setInitialStep = () => ({ type: SET_INITIAL_SHEER_STEP });
export const setRedirectUrl = (payload) => ({ type: SET_REDIRECT_URL, payload });
export const setSheerProgram = (payload) => ({ type: SET_SHEER_PROGRAM, payload });
export const setSheerVerificationId = (payload) => ({ type: SET_SHEER_VERIFICATION_ID, payload });
export const clearSheerId = () => ({ type: CLEAR_SHEER_ID });
export const setVeteransAdvId = (payload) => ({ type: SET_VETERANS_ADV_ID, payload });
export const setVeteransAdvError = (payload) => ({ type: SET_VETERANS_ADV_ERROR, payload });
export const clearVeteransAdvId = () => ({ type: CLEAR_VETERANS_ADV_ID });
export const clearVeteransAdvError = () => ({ type: CLEAR_VETERANS_ADV_ERROR });

// action thunks

//bango
export const checkBangoParams = () => (dispatch) => {
  const windowUrl = window?.location?.search?.replace('\\u0026', '&');
  const query = new URLSearchParams(windowUrl);
  const subscriptionId = query.get('subscriptionRequestId') || localStorageGet('subscriptionRequestId') || '';
  const redirectUrl = query.get('redirect_uri') || localStorageGet('redirect_uri') || '';
  const productId = query.get('productId') || localStorageGet('productId') || '';

  if (subscriptionId) {
    localStorageSet('subscriptionRequestId', subscriptionId);
    localStorageSet('redirect_uri', redirectUrl);
    localStorageSet('productId', productId);
    return dispatch(setBango({ subscriptionId, redirectUrl, productId }));
  }
};

export const addRedirectUrl = (redirectUrl) => (dispatch) => {
  const sanitizedUrl = sanitizePath(redirectUrl);
  if (sanitizedUrl !== false) {
    localStorageSet('redirect_uri', sanitizedUrl);
    return dispatch(setRedirectUrl(sanitizedUrl));
  }
};

//sheerid
export const getUserSheerInfo = () => async (dispatch) => {
  const response = await getMemberVerify();
  const { program, verificationId, verifier } = response;

  if (verifier !== 'sheerid') {
    throw new Error(MOCK_SHEER_ERROR);
  }

  batch(() => {
    dispatch(setSheerVerificationId(verificationId));
    dispatch(setSheerProgram(program));
  });
  return response;
};

export const clearIntegrations = () => (dispatch) => {
  localStorageRemove('subscriptionRequestId');
  localStorageRemove('redirect_uri');
  localStorageRemove('productId');
  dispatch(resetIntegrations());
};
